import React from "react";
import PropTypes from "prop-types";

import TitledRange from "components/TitledRange";

import styles from "forms/forms.css";

const RangeField = ({
  field: { name, value = {} },
  isEdit,
  onEdit,
  label,
  form: { errors, setFieldValue },
  separator,
  unitField,
  units,
}) => (
  <div className={styles.field}>
    <TitledRange
      from={value.from}
      isEdit={isEdit}
      isRequired={errors[name]}
      onEdit={onEdit}
      onFromInput={(from) => setFieldValue(name, { ...value, from })}
      onToInput={(to) => setFieldValue(name, { ...value, to })}
      onUnitSelect={(unit) => setFieldValue(name, { ...value, [unitField]: unit })}
      separator={separator}
      title={label}
      to={value.to}
      unit={value[unitField]}
      units={units}
    />
  </div>
);

RangeField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.object,
    onChange: PropTypes.func,
  }),
  form: PropTypes.object, // eslint-disable-line
  isEdit: PropTypes.bool,
  label: PropTypes.string,
  onEdit: PropTypes.func,
  separator: PropTypes.string.isRequired,
  units: PropTypes.arrayOf(PropTypes.string).isRequired,
  unitField: PropTypes.string,
};

RangeField.defaultProps = {
  isEdit: true,
  unitField: "unit",
};

export default RangeField;
